import { styled } from '@mui/system';

export const ModalTitleHeading = styled('h1')({
  fontWeight: '600',
  fontSize: '3rem',
  color: '#5e6278',
  marginBottom: '10px',
});
